module.exports = __webpack_public_path__ + "static/media/logotrimap-short.732a1231.png";